import { CharComp } from '@/components/CharComp'
import { TableItem, TableItemCell } from '@/components/TableItem'
import '@/layouts/handicap-real-time-transaction-header.scss'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { useI18n } from 'i18n-utils'
import { useDoubleContractKlineStore } from 'store'
import { useContractChangeSymbol, useResponsive } from 'store/src/hooks'
import { SocketEventName } from 'store/src/socket/SocketService'
import { useWebSocketStore } from 'store/src/stores/use-web-socket'
import '../styles/real-time-transaction-layout.scss'

const initList = (arrayLength: number) => {
  return Array.from({ length: arrayLength }, () => ({
    T: undefined,
    p: '--',
    q: '--',
    s: '--',
    E: 0,
    a: 0,
    m: '',
  }))
}

export const RealTimeTransaction = defineComponent({
  setup() {
    const { doubleMSocketService } = useWebSocketStore()

    const klineStore = useDoubleContractKlineStore()
    const { t } = useI18n()
    const responsive = useResponsive()
    const arrayLength = computed(() => {
      if (responsive.isMobile) {
        return 19
      }
      return 4
    })
    const list = ref<SocketResponse.OrderData[]>(initList(arrayLength.value))

    onMounted(() => {
      doubleMSocketService.onMessage<SocketResponse.OrderResponse>(SocketEventName.Order, (response) => {
        if (klineStore.currentSymbolId !== Number(response.params.p)) return
        const newList = response.data.slice(0, arrayLength.value)
        if (list.value.length !== newList.length) {
          list.value = newList
        } else {
          list.value.forEach((item, index) => {
            item.p = newList[index].p
            item.q = newList[index].q
            item.T = newList[index].T
            item.m = newList[index].m
          })
        }
      })
    })

    useContractChangeSymbol(() => {
      list.value = initList(arrayLength.value)
    })

    const formattedList = computed(() =>
      list.value.map((item) => {
        return {
          T: item.T ? dayjs(item.T).format('HH:mm:ss') : '--',
          p: item.p.formatNumberWithCommas?.() ?? '--',
          q: item.q.formatNumberWithCommas?.() ?? '--',
          m: item.m,
        }
      }),
    )

    return () => (
      <div class="real-time-transaction-layout">
        <div class="handicap-real-time-transaction-header">
          <div class="header">
            <div class="header-item">
              <CharComp>{t('时间')}</CharComp>
            </div>
            <div class="header-item">
              <CharComp>
                {t('价格')}({klineStore.getToSymbolName()})
              </CharComp>
            </div>
            <div class="header-item">
              <CharComp>
                {t('数量')}({klineStore.getFromSymbolName()})
              </CharComp>
            </div>
          </div>
        </div>
        <div class={'handicap-real-time-transaction-body real-time-transaction-body show'}>
          {formattedList.value.map((item, index) => (
            <TableItem key={index}>
              <TableItemCell>
                <CharComp>{item.T || '--'}</CharComp>
              </TableItemCell>
              <TableItemCell
                class={classNames('table-body-item-cell', {
                  up: item.m !== '0',
                  down: item.m === '0',
                })}
              >
                <CharComp>{item.p || '--'}</CharComp>
              </TableItemCell>
              <TableItemCell>
                <CharComp>{item.q || '--'}</CharComp>
              </TableItemCell>
            </TableItem>
          ))}
        </div>
      </div>
    )
  },
})
